import React from "react";
import { Link } from "react-router-dom";
import { formatPrice, siteConfig } from "../Datas/productData";
import "../css/footer.scss";

function Footer() {
  const footerGroups = [
    {
      title: "Service",
      links: [
        { label: "Storefinder", to: "/contact" },
        { label: "FAQs", to: "/faqs" },
        { label: "Returns", to: "/returns" },
        { label: "About us", to: "/about" },
      ],
    },

    {
      title: "Pay and ship",
      links: [
        { label: "Payment and shipping", to: "/shipping" },
        { label: "Return information", to: "/returns" },
        { label: "Online tracking system", to: "/shipping#tracking" },
        { label: "Shopping bag", to: "/cartpage" },
      ],
    },
  ];

  return (
    <footer className="lk-footer" role="contentinfo">
      <div className="lk-footer__navigation">
        <div className="lk-footer__link-grid">
          {footerGroups.map((group) => (
            <nav key={group.title} aria-label={`${group.title} links`}>
              <h3>{group.title}</h3>
              {group.links.map((link) =>
                link.href ? (
                  <a key={link.label} href={link.href}>
                    {link.label}
                  </a>
                ) : (
                  <Link key={link.label} to={link.to}>
                    {link.label}
                  </Link>
                )
              )}
            </nav>
          ))}
          <address className="lk-footer__contact-group">
            <h3>Contact</h3>
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email}
            </a>
            <span>{siteConfig.legalName}</span>
            <span>{siteConfig.contact.location}</span>
          </address>
        </div>
      </div>

      <div className="lk-footer__bottom">
        <p>
          © {new Date().getFullYear()} {siteConfig.displayName}{" "}
          {siteConfig.brandLine}
        </p>
        <nav aria-label="Legal links">
          <Link to="/terms">Terms &amp; conditions</Link>
          <Link to="/privacy">Privacy policy</Link>
          <Link to="/cookies">Cookie policy</Link>
          <Link to="/faqs">FAQs</Link>
        </nav>
        <p>
          {siteConfig.currency} · Free shipping from{" "}
          {formatPrice(siteConfig.shipping.freeThreshold)}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
